import {Button, ButtonProps} from '@hm/fundamental'
import {mdiClose} from '@mdi/js'
import {useTranslation} from 'react-i18next'

export interface ConfirmDialogActionsProps {
  showCancelButton?: boolean
  onCancel?: () => void | Promise<void>
  mainAction: {
    color?: ButtonProps['color']
    variant?: ButtonProps['variant']
    text: string
    icon?: ButtonProps['icon']
    onAction?: () => void | Promise<void>
  }
}

export const ConfirmDialogActions: React.FC<ConfirmDialogActionsProps> = ({
  showCancelButton = true,
  onCancel,
  mainAction: {color = 'primary', icon, text, onAction, variant}
}) => {
  const {t} = useTranslation()
  return (
    <div className="flex justify-end gap-4">
      {showCancelButton && (
        <Button
          variant="secondary"
          data-cy="confirm_dialog_cancel_button"
          onClick={() => void onCancel?.()}
          icon={mdiClose}
        >
          {t('common.cancel')}
        </Button>
      )}
      <Button
        variant={variant}
        data-cy="confirm_dialog_main_action_button"
        onClick={() => void onAction?.()}
        icon={icon}
        color={color}
      >
        {text}
      </Button>
    </div>
  )
}
